import { USER_IMPERSONATE } from "../actions/ImpersonateAction";

const initialState = {
  isUpdate: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_IMPERSONATE:
      return {
        ...state,
        isUpdate: action.payload,
      };
   
    default:
      return state;
  }
};